import script from "./DefaultFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultFooter.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultFooter.vue?vue&type=style&index=0&id=db7d34d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db7d34d8"]])

export default __exports__